export default __webpack_public_path__ + "static/media/amparo-arte-9.d9e2baf7.webp";